// Receipt status constants
// see: app/models/receipt.rb, enum: status

// Statuses where a Receipt is eligible for the manual web putaway flow.
export const RECEIPT_PUTAWAYABLE_STATUSES = [
  'pending_putaway',
  'putting_away'
];

// Tag color mapping for the putaway page header.
export const RECEIPT_STATUS_COLORS = {
  pending_putaway: 'orange',
  putting_away: 'processing',
  done: 'success'
};
